import React, {
  createContext,
  useContext,
  useState,
  ReactNode,
  useEffect,
  useCallback,
} from 'react'
import { Profile } from 'src/api/models/Profile'
import { useMarker } from 'src/context/Marker'
import { skuit } from 'src/services/skuit'

interface IProfileContext {
  profile: Profile | null
  updateProfile: (force?: boolean) => void
  unsetProfile: () => void
}

export const ProfileContext = createContext<IProfileContext>({} as IProfileContext)

export function ProfileProvider({ children }: { children: ReactNode }): JSX.Element {
  const [profile, setProfile] = useState<Profile | null>(null)
  const { setReporter } = useMarker()

  const updateProfile = useCallback(
    (force: boolean = false) => {
      if (profile && !force) {
        return
      }
      skuit.base.profiles.me().then((profile) => {
        setProfile(profile)
        setReporter(profile)
      })
    },
    [profile, setReporter]
  )

  const unsetProfile = () => {
    setProfile(null)
  }

  useEffect(() => {
    updateProfile()
  }, [updateProfile])

  return (
    <ProfileContext.Provider value={{ profile, updateProfile, unsetProfile }}>
      {children}
    </ProfileContext.Provider>
  )
}

export default function useProfileContext() {
  const context = useContext(ProfileContext)
  if (context === undefined) {
    throw new Error('useProfileContext must be used within a ProfileProvider')
  }
  return context
}

